import React, { useState, useEffect } from "react";
import { useImpersonation } from "../../context/Impersonation/ImpersonationContext";

const ImpersonationBanner = () => {
  const { isImpersonating, targetCompany, startedAt, endImpersonation } = useImpersonation();
  const [elapsed, setElapsed] = useState("");

  useEffect(() => {
    if (!isImpersonating || !startedAt) return;

    const tick = () => {
      const ms = Date.now() - new Date(startedAt).getTime();
      const totalSec = Math.floor(ms / 1000);
      const h = Math.floor(totalSec / 3600);
      const m = Math.floor((totalSec % 3600) / 60);
      const s = totalSec % 60;
      setElapsed(
        (h > 0 ? h + "h " : "") +
        String(m).padStart(2, "0") + "m " +
        String(s).padStart(2, "0") + "s"
      );
    };

    tick();
    const timer = setInterval(tick, 1000);
    return () => clearInterval(timer);
  }, [isImpersonating, startedAt]);

  if (!isImpersonating) return null;

  return (
    <div style={{
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      background: "linear-gradient(90deg, #e65100 0%, #ff9800 100%)",
      color: "#fff",
      padding: "10px 20px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      zIndex: 99999,
      fontFamily: "sans-serif",
      fontSize: 14,
      fontWeight: 600,
      boxShadow: "0 2px 8px rgba(0,0,0,0.3)"
    }}>
      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
        <span style={{ fontSize: 18 }}>⚠️</span>
        <span>
          MODO SUPORTE ATIVO&nbsp;|&nbsp;
          Acessando: <strong>{targetCompany?.name}</strong>
          {targetCompany?.id ? ` (ID: ${targetCompany.id})` : ""}
        </span>
        {elapsed && (
          <span style={{
            background: "rgba(0,0,0,0.2)",
            borderRadius: 4,
            padding: "2px 8px",
            fontSize: 12,
            fontFamily: "monospace"
          }}>
            {elapsed} / 2h00m00s
          </span>
        )}
      </div>
      <button
        onClick={() => endImpersonation(false)}
        style={{
          background: "#fff",
          color: "#e65100",
          border: "none",
          padding: "8px 18px",
          borderRadius: 6,
          cursor: "pointer",
          fontWeight: 700,
          fontSize: 13,
          display: "flex",
          alignItems: "center",
          gap: 6
        }}
      >
        🚪 Sair da Conta
      </button>
    </div>
  );
};

export default ImpersonationBanner;
